<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1"><span class="CharOverride-2"><a id="_idTextAnchor000"></a>murder in copper</span></p>
<p class="ORIM-Book-Subtitle--Front-Matter-"><span class="CharOverride-2">deputy allred &amp; apache officer victor</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-2">Virgil Alexander</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><img src="image/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled433.vue?12786ebe